import type { FC } from 'react';

import type { IconName } from '@catalyze/ui';
import { Icon } from '@catalyze/ui';

import { IconWrapper } from './styled';

interface IContactIcon {
    icon: IconName;
    contacted?: boolean;
}

export const ContactIcon: FC<IContactIcon> = ({ icon, contacted }) => (
    <IconWrapper contacted={contacted}>
        <Icon iconName={icon} />
    </IconWrapper>
);
